import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
// import axios from 'axios';
import cookieUtils from '../../utils/cookieUtils';
import SelectLessonModal from './SelectLessonModal';
import { _axios } from '../../utils/axios';

const CreateLesson = ({ show, onHide, chapterId, chapterTitle }) => {
    const containsInvalidCharacters = (text) => {
        // This regex pattern will detect emojis and many special unicode characters
        const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;

        // Test if the text contains emojis or other invalid characters
        return emojiRegex.test(text);
    };
    // Get user ID from cookies
    const userRole = cookieUtils.getSecureCookie('role');
    const adminId = cookieUtils.getSecureCookie('admin_id');
    const userId = cookieUtils.getSecureCookie('user_id');

    // Use appropriate ID based on user role
    const currentId = userRole === 'superadmin' ? adminId : userId;

    const [lessonTitle, setLessonTitle] = useState('');
    const [lessonDescription, setLessonDescription] = useState('');
    const [lessonStatus, setLessonStatus] = useState('New');
    const [selectedArtifact, setSelectedArtifact] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSelectModal, setShowSelectModal] = useState(false);
    const [courseType, setCourseType] = useState('');
    const [courseLanguage, setCourseLanguage] = useState('');
    const [courseId, setCourseId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [lessonTitleMar, setLessonTitleMar] = useState('');
    const [lessonTitleHin, setLessonTitleHin] = useState('');
    const [lessonTitleGuj, setLessonTitleGuj] = useState('');
    const [lessonDescriptionMar, setLessonDescriptionMar] = useState('');
    const [lessonDescriptionHin, setLessonDescriptionHin] = useState('');
    const [lessonDescriptionGuj, setLessonDescriptionGuj] = useState('');

    useEffect(() => {
        if (chapterId) {
            fetchChapterInfo();
        }
    }, [chapterId]);

    useEffect(() => {
        if (show && chapterId && courseId) {
          const checkSequential = async () => {
            const validationResult = await validateSequentialLessons();
            if (!validationResult.isValid) {
              toast.warning(validationResult.message);
            }
          };
          
          checkSequential();
        }
      }, [show, chapterId, courseId]);

    const fetchChapterInfo = async () => {
        try {
            setIsLoading(true);

            // First, get the chapter to find the course_id
            const chapterResponse = await _axios.get(`${ServerPath}/chapter/${chapterId}`);

            if (chapterResponse.data.success) {
                const chapterData = chapterResponse.data.data;
                const courseId = chapterData.course_id;
                setCourseId(courseId);

                // Then, get the course to find the course_type
                const courseResponse = await _axios.get(`${ServerPath}/course/${courseId}`);

                if (courseResponse.data.success) {
                    const courseData = courseResponse.data.data;
                    setCourseType(courseData.course_type);
                    setCourseLanguage(courseData.language || '');
                }
            }
        } catch (error) {
            console.error('Error fetching chapter or course info:', error);
            toast.error('Failed to load course information');
        } finally {
            setIsLoading(false);
        }
    };

    // Add after fetchChapterInfo function
    const validateSequentialLessons = async () => {
        try {
            // Get all chapters for the course
            const chaptersResponse = await _axios.get(`${ServerPath}/chapter/course/${courseId}`);

            if (chaptersResponse.data.success) {
                const chapters = chaptersResponse.data.data;

                // Sort chapters by sequence number
                chapters.sort((a, b) => a.sequence_number - b.sequence_number);

                // Find current chapter's position
                const currentChapterIndex = chapters.findIndex(chapter => chapter.chapter_id === chapterId);

                // Check all previous chapters
                for (let i = 0; i < currentChapterIndex; i++) {
                    const prevChapter = chapters[i];

                    // Check if previous chapter has lessons
                    const lessonsResponse = await _axios.get(`${ServerPath}/lesson/chapter/${prevChapter.chapter_id}`);

                    if (lessonsResponse.data.success) {
                        const lessons = lessonsResponse.data.data;

                        // If previous chapter has no lessons, return false with chapter info
                        if (!lessons || lessons.length === 0) {
                            return {
                                isValid: false,
                                message: `Chapter ${prevChapter.sequence_number}: ${prevChapter.title} has no lessons. Please add lessons to this chapter first.`
                            };
                        }
                    }
                }

                // All previous chapters have lessons
                return { isValid: true };
            }
        } catch (error) {
            console.error('Error validating chapter sequence:', error);
            return {
                isValid: false,
                message: 'Error checking previous chapters. Please try again.'
            };
        }
    };

    const containsAlphanumeric = (text) => {
        const alphanumericRegex = /[a-zA-Z0-9]/; // Matches any letter or number
        return alphanumericRegex.test(text);
    };

    const handleTitleChange = (e) => {
        const value = e.target.value;

        // Validate for emojis and special characters
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", {
                toastId: 'emoji-error'
            });
            return;
        }

        // NEW VALIDATION: Check if title contains at least one alphanumeric character
        if (value.trim() !== '' && !containsAlphanumeric(value)) {
            toast.error("Please enter a valid Lesson Title using letters or numbers.", {
                toastId: 'alphanumeric-error'
            });
            return;
        }

        setLessonTitle(value);
    };

    const handleDescriptionChange = (e) => {
        const value = e.target.value;

        // Validate for emojis and special characters
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", {
                toastId: 'emoji-error'
            });
            return;
        }

        // NEW VALIDATION: Check if description contains at least one alphanumeric character
        if (value.trim() !== '' && !containsAlphanumeric(value)) {
            toast.error("Please enter a valid Lesson Description using letters or numbers.", {
                toastId: 'alphanumeric-error'
            });
            return;
        }

        // Check length only after validations pass
        if (value.length <= 500) {
            setLessonDescription(value);
        } else {
            toast.error("Lesson description cannot exceed 500 characters", {
                toastId: 'length-error'
            });
        }
    };

    const handleMultilingualTitleChange = (setter) => (e) => {
        const value = e.target.value;
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", { toastId: 'emoji-error' });
            return;
        }
        setter(value);
    };

    const handleMultilingualDescriptionChange = (setter) => (e) => {
        const value = e.target.value;
        if (containsInvalidCharacters(value)) {
            toast.error("Please enter valid text. Emojis and unsupported symbols are not allowed.", { toastId: 'emoji-error' });
            return;
        }
        if (value.length > 500) {
            toast.error("Lesson description cannot exceed 500 characters", { toastId: 'length-error' });
            return;
        }
        setter(value);
    };

    const handleStatusChange = (e) => {
        setLessonStatus(e.target.value);
    };

    const handleArtifactSelect = (artifact) => {
        setSelectedArtifact(artifact);
        setShowSelectModal(false);
    };

    const handleSubmit = async () => {
        const titleValidations = [
            { value: lessonTitle, lang: 'English', isEn: true },
            { value: lessonTitleMar, lang: 'Marathi', isEn: false },
            { value: lessonTitleHin, lang: 'Hindi', isEn: false },
            { value: lessonTitleGuj, lang: 'Gujarati', isEn: false },
        ];
        for (const { value, lang, isEn } of titleValidations) {
            if (!value.trim()) {
                toast.error(`${lang} lesson title is required`);
                return;
            }
            if (isEn && !containsAlphanumeric(value)) {
                toast.error("Please enter a valid Lesson Title using letters or numbers.");
                return;
            }
        }

        const descValidations = [
            { value: lessonDescription, lang: 'English', isEn: true },
            { value: lessonDescriptionMar, lang: 'Marathi', isEn: false },
            { value: lessonDescriptionHin, lang: 'Hindi', isEn: false },
            { value: lessonDescriptionGuj, lang: 'Gujarati', isEn: false },
        ];
        for (const { value, lang, isEn } of descValidations) {
            if (!value.trim()) {
                toast.error(`${lang} lesson description is required`);
                return;
            }
            if (isEn && !containsAlphanumeric(value)) {
                toast.error("Please enter a valid Lesson Description using letters or numbers.");
                return;
            }
        }

        if (!selectedArtifact) {
            toast.error('Please select lesson content');
            return;
        }

        if (!lessonStatus) {
            toast.error('Lesson status is required');
            return;
        }

        const validationResult = await validateSequentialLessons();
        if (!validationResult.isValid) {
          toast.error(validationResult.message);
          return;
        }

        try {
            setIsSubmitting(true);

            // Create lesson data object
            const lessonData = {
                user_id: currentId,
                chapter_id: chapterId,
                title: lessonTitle,
                title_mar: lessonTitleMar || null,
                title_hin: lessonTitleHin || null,
                title_guj: lessonTitleGuj || null,
                description: lessonDescription,
                description_mar: lessonDescriptionMar || null,
                description_hin: lessonDescriptionHin || null,
                description_guj: lessonDescriptionGuj || null,
                artifact_id: selectedArtifact.artifact_id,
                status: lessonStatus
            };

            // Make API call to create lesson
            const response = await _axios.post(`${ServerPath}/lesson/create`, lessonData);

            if (response.data.success) {
                toast.success('Lesson has been successfully created');
                resetForm();
                onHide();
            }
        } catch (error) {
            console.error('Error creating lesson:', error);
            toast.error(error.response?.data?.message || 'Failed to create lesson');
        } finally {
            setIsSubmitting(false);
        }
    };



    const resetForm = () => {
        setLessonTitle('');
        setLessonTitleMar('');
        setLessonTitleHin('');
        setLessonTitleGuj('');
        setLessonDescription('');
        setLessonDescriptionMar('');
        setLessonDescriptionHin('');
        setLessonDescriptionGuj('');
        setLessonStatus('New');
        setSelectedArtifact(null);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>Create Lessons</Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <span className="text-muted me-2">Course Type:</span>
                        <span className="badge bg-info">{courseType || 'Loading...'}</span>
                    </div>
                    <div>
                        <span className="text-muted me-2">Last Updated Date -</span>
                        <span className="text-muted">NA</span>
                    </div>
                </div>

                <div className="mt-3">
                    <h6 className="text-primary mb-4">Lesson</h6>

                    {/* Lesson Titles - 4 languages */}
                    <div className="row mb-3">
                        {[
                            { label: 'English', value: lessonTitle, onChange: handleTitleChange },
                            { label: 'Marathi', value: lessonTitleMar, onChange: handleMultilingualTitleChange(setLessonTitleMar) },
                            { label: 'Hindi', value: lessonTitleHin, onChange: handleMultilingualTitleChange(setLessonTitleHin) },
                            { label: 'Gujarati', value: lessonTitleGuj, onChange: handleMultilingualTitleChange(setLessonTitleGuj) },
                        ].map(lang => (
                            <div key={lang.label} className="col-3">
                                <Form.Group>
                                    <Form.Label style={{ fontSize: '14px' }}>
                                        {lang.label} Title <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={`Enter ${lang.label} title`}
                                        value={lang.value}
                                        onChange={lang.onChange}
                                    />
                                </Form.Group>
                            </div>
                        ))}
                    </div>

                    {/* Lesson Descriptions - 2x2 */}
                    <div className="row mb-3">
                        {[
                            { label: 'English', value: lessonDescription, onChange: handleDescriptionChange },
                            { label: 'Marathi', value: lessonDescriptionMar, onChange: handleMultilingualDescriptionChange(setLessonDescriptionMar) },
                            { label: 'Hindi', value: lessonDescriptionHin, onChange: handleMultilingualDescriptionChange(setLessonDescriptionHin) },
                            { label: 'Gujarati', value: lessonDescriptionGuj, onChange: handleMultilingualDescriptionChange(setLessonDescriptionGuj) },
                        ].map(lang => (
                            <div key={lang.label} className="col-6 mb-3">
                                <Form.Group>
                                    <Form.Label style={{ fontSize: '14px' }}>
                                        {lang.label} Description <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder={`Enter ${lang.label} description`}
                                            value={lang.value}
                                            onChange={lang.onChange}
                                            style={{ paddingBottom: '24px' }}
                                        />
                                        <div className="position-absolute bottom-0 end-0 m-2">
                                            <small className={lang.value.length >= 500 ? "text-danger" : "text-muted"}>
                                                {lang.value.length}/500
                                            </small>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        ))}
                    </div>

                    {/* Status and Select Lesson */}
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label>
                                    Lesson Status <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    value={lessonStatus}
                                    onChange={handleStatusChange}
                                >
                                    <option value="New">New</option>
                                    <option value="Active">Active</option>
                                    <option value="Archived">Archived</option>
                                </Form.Select>
                            </Form.Group>
                        </div>

                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label>
                                    Select Lesson <span className="text-danger">*</span>
                                </Form.Label>
                                <div
                                    className="border rounded d-flex align-items-center justify-content-center"
                                    style={{
                                        height: '116px',
                                        cursor: isLoading ? 'wait' : 'pointer',
                                        backgroundColor: selectedArtifact ? '#f8f9fa' : 'white'
                                    }}
                                    onClick={() => !isLoading && setShowSelectModal(true)}
                                >
                                    {selectedArtifact ? (
                                        <div className="text-center p-0" style={{ width: '100%', height: '100%' }}>
                                            <img
                                                src={selectedArtifact.thumbnail_url}
                                                alt={selectedArtifact.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '0.25rem'
                                                }}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://via.placeholder.com/100x70?text=No+Preview';
                                                }}
                                            />
                                            {/* <p className="mb-0 small">{selectedArtifact.title}</p> */}
                                        </div>
                                    ) : isLoading ? (
                                        <div className="text-center text-muted">
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mb-0 mt-2">Loading course info...</p>
                                        </div>
                                    ) : (
                                        <div className="text-center text-muted">
                                            <span style={{ fontSize: '38px', color: '#ccc', fontWeight: '200' }}>+</span>
                                        </div>
                                    )}
                                </div>
                            </Form.Group>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting || isLoading}
                    className="px-4"
                >
                    Save
                </Button>
            </Modal.Footer>

            {/* Select Lesson Modal */}
            {showSelectModal && (
                <SelectLessonModal
                    show={showSelectModal}
                    onHide={() => setShowSelectModal(false)}
                    onSelect={handleArtifactSelect}
                    selectedArtifactId={selectedArtifact?.artifact_id}
                    courseType={courseType}
                    courseLanguage={courseLanguage}
                />
            )}
        </Modal>
    );
};

export default CreateLesson;